import { gql } from '@apollo/client'

export const SET_CUTOFF_DAY_FOR_COUNTRY = gql`
  mutation SetCutoffDayForCountry($country: Country!, $cutoffDay: Int!) {
    setCutoffDayForCountry(country: $country, cutoffDay: $cutoffDay)
  }
`
